<template>
    <div class="card wos__card rounded-lg m-4 shadow justify-content-between w-100">
        <div class="card-header">
            <router-link :to="createRouteObject(catalogNo, categorySlug)">
                <span class="discount-badge" v-if="discountVal > 0">
                    {{discountVal}}%
                </span>
                <img class="card-img-top wos__image-link top-rounded-img_lg" :alt="catalogNo" :src="thumbnail">
            </router-link>
        </div>
        <div class="card-body">
            <h4 class="card-title wos__card-title w-100 text-overflow-hide">{{catalogName}}</h4>
            <router-link :to="createRouteObject(catalogNo, categorySlug)" class="text-wellis-gold">
                <h6 class="card-subtitle mb-2">{{catalogNo}}</h6>
            </router-link>
            <h6 :class="['mt-1 card-subtitle text-muted text-right',
                    quantityInStock === 0 ? 'preorder color-gold' : '']"
                v-if="availability !== false">{{availability}}</h6>
            <hr>
            <div class="mt-3" v-if="priceDisplay">
                <div v-if="discountVal > 0">
                    <div class="row">
                        <div class="col-sm-12 col-md-6" v-if="hasVat">
                            <small class="text-line-through">
                                {{factoryPrice | toPrice(currency, false)}} + {{$t('components.products.vat')}}
                            </small>
                        </div>
                        <div :class="['col-sm-12 col-md-6', hasVat ? 'text-right' : '']">
                            <small class="text-line-through">
                                {{factoryPrice | toPrice(currency, hasVat)}}
                            </small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6" v-if="hasVat">
                            <small class="text-wellis-gold font-weight-bold">
                                {{unitPrice | toPrice(currency, false)}} + {{$t('components.products.vat')}}
                            </small>
                        </div>
                        <div :class="['col-sm-12 col-md-6', hasVat ? 'text-right' : '']">
                            <p class="text-wellis-gold end-price">{{unitPrice | toPrice(currency, hasVat)}}</p>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-sm-12 col-md-6" v-if="hasVat">
                            <small class="text-wellis-gold font-weight-bold">
                                {{unitPrice | toPrice(currency, false)}} + {{$t('components.products.vat')}}
                            </small>
                        </div>
                        <div :class="['col-sm-12 col-md-6', hasVat ? 'text-right' : '']">
                            <p class="text-wellis-gold end-price">{{unitPrice | toPrice(currency, hasVat)}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div v-if="configurable">
                <router-link :to="createRouteObject(catalogNo, categorySlug)" class="btn btn-wos-real col-sm-12">
                    {{$t('components.products.availability.btnConfigurable')}}
                </router-link>
            </div>
            <div v-else>
                <div class="wos__quantity-input d-flex mt-4" style="margin: 0 auto;">
                    <div class="num-button right" @click="decreaseQuantity">
                        <i class=" fas fa-minus"></i>
                    </div>
                    <div>
                        <input type="number" v-model.number="quantity" autocomplete="off">
                    </div>
                    <div class="num-button left" @click="increaseQuantity">
                        <i class="fas fa-plus"></i>
                    </div>
                </div>
                <button class="btn btn-wos-real col-sm-12 mt-5" @click="addCart">
                    {{$t('components.products.availability.btnAddCart')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import CartApiService from "../../api/cart.api";
    import {EVENT_CART_COUNT_UPDATE} from "../../core/constants";

    export default {
        props: {
            product: Object,
            categorySlug: String
        },
        name: "ProductCard",

        data() {
            return {
                quantity: 1
            }
        },

        methods: {
            increaseQuantity() {
                this.quantity++;
                if (this.quantity > 99) {
                    this.quantity = 99;
                }
            },

            decreaseQuantity() {
                this.quantity--;
                if (this.quantity < 1) {
                    this.quantity = 1;
                }
            },

            createRouteObject(catalogNo, categorySlug = null) {
                let route = {
                    name: 'app.product.concrete',
                    params: {
                        catalogNo: catalogNo
                    }
                };

                if (categorySlug) {
                    route.params.category = categorySlug;
                }

                return route;
            },

            addCart() {
                let loader = this.$loading.show();
                let attributes = {
                    "coordinator": "addProductSimple",
                    "product": this.product.catalogNo,
                    "quantity": this.quantity
                };
                CartApiService.add(attributes)
                    .then(response => {
                        this.$eventBus.$emit(EVENT_CART_COUNT_UPDATE, response.data.count);
                    })
                    .catch(error => {
                        console.log('addCart: NOT OK, error:', error);
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    })
            },
        },

        computed: {
            catalogNo() {
                if (!this.product) {
                    return 'N/A';
                }
                return this.product.catalogNo;
            },

            catalogName() {
                if (!this.product) {
                    return 'N/A';
                }
                return this.product.name;
            },

            thumbnail() {
                if (!this.product) {
                    return null;
                }
                return this.product.media.thumbnailUrl;
            },

            discountVal() {
                if (!this.product.price) {
                    return 0;
                }
                return this.product.price.discount;
            },

            availability() {
                if (this.product.catalogType === 'NON' || this.product.configurable) {
                    return false;
                }
                if (this.product.quantityInStock === 0) {
                    return this.$t('components.products.availability.preorder');
                } else {
                    if (this.product.quantityInStock > 20) {
                        return this.$t('components.products.availability.more', {unit: this.product.unit});
                    } else {
                        return this.$t('components.products.availability.less', {unit: this.product.unit});
                    }
                }
            },

            configurable() {
                return this.product.configurable;
            },

            priceDisplay() {
                return this.product.price !== null;
            },

            unitPrice() {
                if (this.product.price === null) {
                    return 0;
                }
                return this.product.price.unitPrice;
            },

            factoryPrice() {
                if (this.product.price === null) {
                    return 0;
                }
                return this.product.price.factoryPrice;
            },

            currency() {
                if (this.product.price === null) {
                    return null;
                }
                return this.product.price.currency;
            },

            hasVat() {
                if (this.product.price === null) {
                    return null;
                }
                return this.product.price.vat;
            },

            quantityInStock() {
                return this.product.quantityInStock;
            }
        },

        watch: {
            'quantity': function (val) {
                if (val === '') {
                    this.quantity = 1;
                }
            }
        }
    }
</script>

<style scoped>
    .preorder {
        animation: preorder-blinker 1s linear infinite;
        font-size: 20px !important;
    }

    @keyframes preorder-blinker {
        50% {
            opacity: 0.4;
        }
    }

    .end-price {
        font-size: 18px;
        font-weight: bold;
    }
</style>
